import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {MandantAuswahlRoute} from './variables';
import {select, Store} from '@ngrx/store';
import {getMandant} from '@orga-app/mandant/reducer';
import {map} from 'rxjs/operators';


export const IsMandantAusgewaehltGuard: CanActivateFn = () => {
    // const router = inject(Router);
    const auswahlRoute = inject(MandantAuswahlRoute);
    const store = inject(Store);

    return store.pipe(select(getMandant),
        map(m => {

            if (m == null) {

                console.debug('mandantGuard: kein mandant:', auswahlRoute);
                return false;
            }
            console.debug('mandantGuard: OK');
            return true;

        }));

    // const mandantid = localStorage.getItem('mandant_id');
//
// if (!mandantid || mandantid === 'undefined' || mandantid === 'null') {
//   return router.parseUrl(auswahlRoute);
// }

// return true;
};


// @Injectable()
// export class IsMandantAusgewaehltGuard implements CanActivate {

//   constructor(private injector: Injector, private _router: Router,
//     @Inject(MandantAuswahlRoute) private auswahlRoute: string,
//     private storeMandant: Store<fromMandantModule.ModuleState>) {

//   }


//   private _oauthService: AuthService = null;
//   private getOAuthService(): AuthService {
//     if (this._oauthService === null) {
//       this._oauthService = this.injector.get(AuthService);
//     }
//     return this._oauthService;
//   }

//   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

//     return this.storeMandant.pipe(select(getMandant),
//       map(m => {

//         if (m == null) {

//           console.debug('mandantGuard: kein mandant:', this.auswahlRoute, state.url, state);

//           return false;
//         }
//         console.debug('mandantGuard: OK');

//         return true;

//       }));
//   }

// }
